import { DismissedMessage } from '../messages/DismissedMessage';
import { SettingsBase } from './SettingsBase';

export class DismissedMessagesSettings extends SettingsBase {
    static NAME_OF_CLASS = 'DismissedMessagesSettings';
    public dismissedMessages: DismissedMessage[] = [];

    public constructor(val?: DismissedMessagesSettings) {
        super();
        this.dismissedMessages = val?.dismissedMessages ?? [];
    }
}
